// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__AqJuj","name":"styles_name__1naj5","phone":"styles_phone__10bnA"};